import { TOUR_ANCHOR_ATTRIBUTE } from './tour.model';

/** La place d'un élément à l'écran, en coordonnées de la fenêtre. */
export interface Spot {
  top: number;
  left: number;
  width: number;
  height: number;
}

/**
 * Le premier élément affiché qui porte cette ancre. Une ancre peut se répéter — l'icône de chaque
 * ligne de la liste — et un élément caché (onglet inactif, ligne repliée) n'a pas de taille.
 */
export function findAnchor(anchor: string, root: ParentNode = document): HTMLElement | null {
  const selector = `[${TOUR_ANCHOR_ATTRIBUTE}="${CSS.escape(anchor)}"]`;
  return (
    Array.from(root.querySelectorAll<HTMLElement>(selector)).find((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }) ?? null
  );
}

export function spotOf(element: Element): Spot {
  const { top, left, width, height } = element.getBoundingClientRect();
  return { top, left, width, height };
}

export function sameSpot(a: Spot | null, b: Spot | null): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  return a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
}
